export interface CalculatorState {
  modalOpen: boolean
}

export const initialState: CalculatorState = {
  modalOpen: false
}
